import React from 'react';
import OfferOverlayLink from 'core/modules/OfferOverlayLink/OfferOverlayLink';
import ClickLink from 'core/modules/ClickLink/ClickLink';

function OfferOverlayOrClickLinkWrap({
  dataItem, sectionId, className, children,
}) {
  const {
    id,
    clickUrl,
    merchant: {
      name,
      id: merchantId,
    },
    offerText: {
      offerTitle,
    },
  } = dataItem;
  const showOfferOverlayLink = offerTitle && offerTitle !== '';

  return (
    <div>
      {
        showOfferOverlayLink ?
          <OfferOverlayLink
            className={className}
            merchantId={merchantId}
            merchantName={name}
            sectionId={sectionId}
            offerId={id}
          >
            {children}
          </OfferOverlayLink> :
          <ClickLink
            url={clickUrl}
            className={className}
            title={`Opens a new window at ${name}`}
            target="_blank"
          >
            {children}
          </ClickLink>
      }
    </div>
  );
}

export default OfferOverlayOrClickLinkWrap;
